/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Invite_MissingInputs */

const cs_auth_invite_missing = /** @type {(inputs: Auth_Invite_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí token pozvánky.`)
};

const en_auth_invite_missing = /** @type {(inputs: Auth_Invite_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing invite token.`)
};

/**
* | output |
* | --- |
* | "Missing invite token." |
*
* @param {Auth_Invite_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_invite_missing = /** @type {((inputs?: Auth_Invite_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Invite_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_invite_missing(inputs)
	return cs_auth_invite_missing(inputs)
});